import { render } from "./CreateLadderInfractionForm.vue?vue&type=template&id=0b7d9ed6"
import script from "./CreateLadderInfractionForm.vue?vue&type=script&lang=js"
export * from "./CreateLadderInfractionForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__